export const AUTH_REQUEST_STATE_KEY = 'authRequest';

export const AUTH_REQUEST_SOURCES = Object.freeze({
  NATIVE_APP_STARTUP: 'native-app-startup',
  PROFILE_NAVIGATION: 'profile-navigation',
});

export function createRequiredAuthRequest({ source, page } = {}) {
  return {
    source,
    page,
    required: true,
  };
}

export function isRequiredAuthRequest(authRequest) {
  return authRequest?.required === true;
}
